import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultIconSetting,
  defaultComplexFontSetting,
  defaultSimpleFontSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "mainSize",
    desc: "尺寸",
    type: "sizeSet",
    defaultValue: {
      widthAuto: true,
      widthFull: false,
      heightAuto: true,
    },
    extraConfig: {
      disabled: true
    }
  },
  {
    name: "direction",
    desc: "方向",
    type: "sliderSet",
    defaultValue: "column",
    extraConfig: {
      options: [
        {
          value: "column",
          label: "",
          iconClass: "icon-portal-direction-down"
        },
        {
          value: "row",
          label: "",
          iconClass: "icon-portal-direction-right"
        },
      ],
      titleStyle: {
        width: "52px",
      },
    },
    height: 32
  },
  {
    name: "margin",
    desc: "间距",
    type: "numberSet",
    defaultValue: 4,
    unit: "px",
    extraConfig: {
      suffix: "px",
      styleId: 2
    }
  },
  {
    name: "mainBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "mainBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "showMainBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "mainRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "mainOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "mainShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "mainPadding",
    desc: "内边距",
    type: "paddingSet",
    defaultValue: {
      ...defaultPaddingSetting,
      padding: 8,
    }
  },
]

export const menuSetting = [
  {
    type: "collapse",
    title: "尺寸",
    settings: ["mainSize"]
  },
  {
    type: "collapse",
    title: "排列",
    settings: ["direction", "margin"]
  },
  {
    type: "collapse",
    title: "背景",
    settings: ["mainBackground"]
  },
  {
    type: "collapse",
    title: "边框",
    initStatus: 'closed',
    settings: [
      {
        type: "basic",
        name: "mainBorder",
      },
      "mainRadius"
    ]
  },
  {
    type: "collapse",
    title: "边距",
    initStatus: 'closed',
    settings: ["mainPadding"]
  },
  {
    type: "collapse",
    title: "更多",
    initStatus: 'closed',
    settings: ["mainOpacity", "mainShadow"]
  }
]
